//  ==========================================================================
//
//  Newsletter
//
//  ==========================================================================
import React, { PureComponent } from 'react';

import { MetaTags, NewsletterForm } from '../components';

import styled from 'react-emotion';

import { css } from 'emotion';
import { mq } from '../global-styles';

import BackgroundImage from '../assets/images/newsletter-background.jpg';

const StyledFormContainer = styled( 'section' )`
	background: url(${BackgroundImage}) no-repeat center 45px fixed; 
	padding: 80px 0 40px;

	${mq.md(
		css`
			background-position: center 60px;
			padding: 120px 0 40px;
		`
	)};

	${mq.lg(
		css`
			background-position: center 80px;
			background-size: cover;
		`
	)};

	.newsletter-form {
		background: white;
		margin: 0 auto;
		max-width: 750px;
		padding: 0 20px 25px;
		width: 95%;

		${mq.md(
		css`
			padding-bottom: 60px;
		`
	)};

		&:before {
			display: none;
		}
	}

	form {
		max-height: none;
	}
`;

export default class Newsletter extends PureComponent {
	render() {
		return (
			<main
				id="main"
			>
				<MetaTags post_title="Newsletter" />

				<StyledFormContainer>
					<NewsletterForm/>
				</StyledFormContainer>
			</main>
		);
	}
}
